import React from 'react';
import styled from 'styled-components';

const InfoBlock = ({ tagLine, simpleText }) => {
  return (
    <InfoContainer>
      <InfoInner>
        <GoldLine />
        <TagLine>{tagLine}</TagLine>
        {simpleText && <SubText>{simpleText}</SubText>}
      </InfoInner>
    </InfoContainer>
  );
};

const InfoContainer = styled.div`
  background: #f9fafb;
  padding: 56px 32px 48px;
  @media (max-width: 768px) {
    padding: 40px 20px 36px;
  }
`;

const InfoInner = styled.div`
  max-width: 760px;
  margin: 0 auto;
  text-align: center;
`;

const GoldLine = styled.div`
  width: 48px;
  height: 4px;
  background: #c89432;
  border-radius: 2px;
  margin: 0 auto 20px;
`;

const TagLine = styled.h2`
  font-family: "Poppins", sans-serif;
  font-size: clamp(1.25rem, 2.5vw, 1.75rem);
  font-weight: 700;
  color: #111827;
  line-height: 1.4;
  margin-bottom: 12px;
`;

const SubText = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 1rem;
  color: #6b7280;
  font-style: italic;
  line-height: 1.65;
`;

export default InfoBlock;
